import React, {useMemo} from 'react';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import LineChart from '@/pages/dashboard/_charts/LineChart';
import colors from 'tailwindcss/colors';
import {useEventsContext} from "@/pages/dashboard/EventsContext";
import getInvitationActivityChartData from "@/pages/dashboard/_utils/getInvitationActivityChartData";

export default function InvitationsByMonth(props) {
  const {timestamps} = props;
  const {filteredInvitations, isLoadingInvitations} = useEventsContext();

  if (isLoadingInvitations) {
    return (
      <ChartLoader
        title="Event invitation breakdown"
        subtitle="Over school year"
      />
    );
  }

  const {series, labels} = useMemo(() => getInvitationActivityChartData(filteredInvitations, timestamps),
    [filteredInvitations, timestamps]);

  return (
    <LineChart
      title="Event invitation breakdown"
      subtitle="Over school year"
      labels={labels}
      series={series}
      colors={[
        colors.neutral['400'],
        colors.emerald['400'],
        colors.blue['400'],
        colors.yellow['400'],
        colors.red['400']
      ]}
    />
  );
}
